import React from 'react';
import { Box, Text } from '@theme-ui/components';
import { Icon } from '../atoms';
import { InfoTile } from '../molecules';
import { typography, colors } from '../../styles/theme';

const labelStyle = { ...typography.textSm, color: colors.black };

const tagColor = {
	Template: 'blue',
	Guide: 'orange',
	Blog: 'green',
	'Reports & Insights': 'orange400'
};

const BottomLabel = ({ topic }) => (
	<Box>
		<Icon
			name='Tag'
			color={colors.black}
			size={16}
		/>
		<Text sx={{ pl: '0.5rem', ...labelStyle }}>{topic}</Text>
	</Box>
);

const getLink = (type, slug) => {
	switch (type) {
		case 'compliance':
			return `/wiki/compliances/${slug}/`;
		case 'act':
			return `/wiki/acts/${slug}/`;
		case 'notification':
			return `/notifications/${slug}/`;
		case 'Blog':
			return `/blog/${slug}/`;
		case 'hr-garden':
			return `/${slug}`;
		default:
			return `/${slug}/`;
	}
};

export const PageHit =
	() =>
	({ hit }) => {
		const { type, slug, region, name, description, topic, image } = hit;
		let link = getLink(type, slug);
		if (region && region === 'ME') {
			link = `/middle-east${link}`;
		}
		let tagLable;
		const regex = /^reports\/.+/;

		if(regex.test(slug)){
			tagLable = 'Reports & Insights'
		} else {
			tagLable = type;
		}

		return (
			<InfoTile
				title={name}
				bottomLabel={topic && <BottomLabel topic={topic} />}
				tagLabel={tagLable}
				tagColor={tagColor[tagLable]}
				imageUrl={image?.url}
				imageAltText={name}
				hasBorder={false}
				content={description}
				url={link}
				customStyles={{
					".url-image": {
						width: "100%",
						height: "10.625rem"
					}
				}}
			/>
		);
	};
